import { StyleSheet } from '@react-pdf/renderer'

export const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  table: {
    display: 'flex',
    marginTop: 10,
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1pt solid black',
    borderBottom: '2pt solid black',
    fontFamily: 'Helvetica-Bold',
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1pt solid black',
    backgroundColor: '#f0f0f0',
  },
  tableRowOdd: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1pt solid black',
    backgroundColor: '#ffffff',
  },
  tableCell: {
    padding: 5,
    textAlign: 'center',
    borderLeft: '1pt solid black',
    flexGrow: 1,
  },
  tableCellLast: {
    padding: 5,
    textAlign: 'center',
    borderLeft: '1pt solid black',
    borderRight: '1pt solid black',
    flexGrow: 1,
  },
  col3: {
    flex: '0 0 25%',
    maxWidth: '25%',
    boxSizing: 'border-box',
  },
  col2: {
    flex: '0 0 16.66%',
    maxWidth: '16.66%',
    boxSizing: 'border-box',
  },
  col1: {
    flex: '0 0 8.33%',
    maxWidth: '8.33%',
    boxSizing: 'border-box',
  },
  col1_5: {
    flex: '0 0 12.495%',
    maxWidth: '12.495%',
    boxSizing: 'border-box',
  },
})
